import React from 'react';

// @context TGW-1769 チャンネルヘッダ。⚙設定は owner/manager のみ・チャンネル実体があるもののみ
//   （全体=仮想チャンネルは名前変更等の対象外のため出さない）。
//   人数（👤N）は Slack TTP でクリック可能にし、メンバー一覧モーダル（onOpenMembers）を開く。
export default function ChannelHeader({
  channel,
  numberOfMembers,
  canManage,
  onOpenDrawer,
  onOpenSettings,
  onOpenMembers,
}) {
  return (
    <div className="slackch-header">
      <button
        type="button"
        className="slackch-drawer-toggle"
        onClick={onOpenDrawer}
        aria-label="チャンネル一覧"
      >
        ☰
      </button>
      <div className="slackch-header-title">
        {channel.isPrivate ? '🔒' : '#'} {channel.name}
      </div>
      {channel.description ? (
        <div className="slackch-header-desc">{channel.description}</div>
      ) : null}
      <div className="slackch-header-right">
        {numberOfMembers != null && (
          <button
            type="button"
            className="slackch-header-members"
            onClick={onOpenMembers}
            title="メンバー一覧"
          >
            👤 {numberOfMembers}
          </button>
        )}
        {canManage && !channel.isGeneral && (
          <button
            type="button"
            className="slackch-header-settings"
            onClick={onOpenSettings}
            aria-label="チャンネル設定"
          >
            ⚙
          </button>
        )}
      </div>
    </div>
  );
}
